<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import Icon from "~/components/icon/Icon.vue";
import Sprites from "~/components/icon/Sprites.vue";

definePageMeta({
  layout: "default",
  name: "index",
});

useHead(getMeta(
  `XSQUARE`,
  `XSQUARE`,
));
</script>

<template>
  <div class="page-index">
    <div class="page-index-grid container">
      <div class="page-index-grid-row">
        <h1 class="page-index-h1">
          XSQUARE - the world's only Low&nbsp;Code&nbsp;PostgreSQL development environment for creating corporate information systems
        </h1>
      </div>

      <div class="page-index-grid-row">
        <div class="page-index-grid-more-v2">
          <h2 class="s-1">
            <span class="s-2">XSQUARE 5.3</span> <br hide-xs>
            is available on <span style="white-space: nowrap">demo stand</span>
          </h2>
          <div class="buttons">
            <nuxt-link to="/demo/" class="btn btn--fluid">DEMO 5.3</nuxt-link>
          </div>
        </div>
      </div>

      <div class="page-index-grid-row">
        <a href="https://lcdp.xsquare.dev/" target="_blank" class="page-index-tile page-index-tile--red">
          <div class="page-index-tile__icon"><icon name="icon-cog"/></div>
          <div class="page-index-tile__title">XRAD</div>
          <div class="page-index-tile__descr">IDE – Integrated Development Environment</div>
          <div class="page-index-tile__more">more details <icon name="icon-arrow-right"/></div>
        </a>
      </div>

      <div class="page-index-grid-row">
        <a href="https://lcdp.xsquare.dev/" target="_blank" class="page-index-tile page-index-tile--orange">
          <div class="page-index-tile__icon"><icon name="icon-cloud"/></div>
          <div class="page-index-tile__title">PGHS</div>
          <div class="page-index-tile__descr">Application server</div>
          <div class="page-index-tile__more">more details <icon name="icon-arrow-right"/></div>
        </a>
      </div>

      <div class="page-index-grid-row">
        <a href="https://xdac.xsquare.dev/" target="_blank" class="page-index-tile page-index-tile--blue">
          <div class="page-index-tile__icon"><icon name="icon-code"/></div>
          <div class="page-index-tile__title">XDAC</div>
          <div class="page-index-tile__descr">RESTful API Server</div>
          <div class="page-index-tile__more">more details <icon name="icon-arrow-right"/></div>
        </a>
      </div>

      <div class="page-index-grid-row">
        <a href="https://xreports.xsquare.dev/"  target="_blank" class="page-index-tile page-index-tile--green">
          <div class="page-index-tile__icon"><icon name="icon-graph"/></div>
          <div class="page-index-tile__title">XREPORTS</div>
          <div class="page-index-tile__descr">Reports server</div>
          <div class="page-index-tile__more">more details <icon name="icon-arrow-right"/></div>
        </a>
      </div>

      <div class="page-index-grid-row">
        <h2 class="page-index-description">
          <icon name="icon-arrow-down"/>

          <p class="s-1">4 components to build a product from scratch</p>
          <p class="s-2">Application Development <br hide-md>
            <span class="text-violet bold">up to 10 times faster</span> and <br>
            <span class="text-green bold">100 time less code</span>
          </p>
        </h2>
      </div>
    </div>

    <sprites>
      <symbol id="icon-arrow-down" viewBox="4.976 4.164 9.8618 97.732" fill="none">
        <path d="M 9.524 4.689 C 9.817 3.989 10.292 3.989 10.585 4.689 L 14.618 10.068 C 14.911 10.771 14.911 11.91 14.618 12.613 C 14.325 13.316 13.85 13.316 13.557 12.613 L 10.055 8.505 L 6.256 12.909 C 5.963 13.612 5.488 13.612 5.195 12.909 C 4.903 12.206 4.903 11.067 5.195 10.364 L 9.524 4.689 Z M 9.305 101.896 L 9.305 5.963 L 10.805 5.963 L 10.805 101.896 L 9.305 101.896 Z" fill="currentcolor"/>
      </symbol>
      <symbol id="icon-arrow-right" viewBox="0 0 20 12" fill="none">
        <path d="M19.5303 6.53033C19.8232 6.23744 19.8232 5.76256 19.5303 5.46967L14.7574 0.696699C14.4645 0.403806 13.9896 0.403806 13.6967 0.696699C13.4038 0.989593 13.4038 1.46447 13.6967 1.75736L17.9393 6L13.6967 10.2426C13.4038 10.5355 13.4038 11.0104 13.6967 11.3033C13.9896 11.5962 14.4645 11.5962 14.7574 11.3033L19.5303 6.53033ZM0 6.75H19V5.25H0V6.75Z" fill="currentcolor"/>
      </symbol>
      <symbol id="icon-cog" viewBox="0 0 54 54" fill="none">
        <path d="M33.4014 54H20.5986V48.3773C19.1473 47.9435 17.746 47.3625 16.4115 46.6415L12.4347 50.6185L3.38164 41.5654L7.35855 37.5886C6.63757 36.2541 6.05665 34.8528 5.62286 33.4015H0V20.5987H5.62275C6.05654 19.1474 6.63746 17.7461 7.35845 16.4115L3.38154 12.4347L12.4346 3.38164L16.4114 7.35855C17.7459 6.63757 19.1472 6.05665 20.5985 5.62286V0H33.4014V5.62275C34.8528 6.05654 36.254 6.63746 37.5884 7.35845L41.5653 3.38164L50.6184 12.4346L46.6415 16.4115C47.3625 17.746 47.9435 19.1473 48.3771 20.5986H54V33.4014H48.3773C47.9436 34.8527 47.3626 36.254 46.6417 37.5885L50.6185 41.5654L41.5654 50.6184L37.5885 46.6415C36.2541 47.3625 34.8529 47.9435 33.4015 48.3773V54H33.4014ZM23.7626 50.8359H30.2375V45.9148L31.453 45.6254C33.4204 45.1569 35.2934 44.3804 37.0201 43.3177L38.0843 42.6627L41.5654 46.1438L46.1438 41.5654L42.6626 38.0844L43.3177 37.0202C44.3804 35.2934 45.1569 33.4204 45.6254 31.453L45.9148 30.2375H50.8359V23.7627H45.9148L45.6254 22.5472C45.1569 20.5798 44.3804 18.7067 43.3177 16.98L42.6626 15.9158L46.1438 12.4348L41.5654 7.85637L38.0843 11.3375L37.0201 10.6825C35.2934 9.61981 33.4204 8.84334 31.453 8.37485L30.2375 8.08545V3.16406H23.7626V8.08523L22.5471 8.37464C20.5797 8.84313 18.7067 9.61959 16.9799 10.6823L15.9157 11.3373L12.4347 7.85626L7.85637 12.4346L11.3374 15.9156L10.6824 16.9798C9.6197 18.7066 8.84324 20.5796 8.37475 22.547L8.08534 23.7625H3.16406V30.2373H8.08523L8.37464 31.4528C8.84313 33.4202 9.61959 35.2932 10.6823 37.02L11.3373 38.0842L7.85626 41.5652L12.4346 46.1435L15.9156 42.6625L16.9798 43.3175C18.7066 44.3802 20.5796 45.1567 22.547 45.6251L23.7625 45.9146L23.7626 50.8359Z" fill="#FFD5D0" fill-opacity="0.3"/>
        <path d="M19.1011 32.5934L13.5078 27.0001L19.1011 21.4067L21.3384 23.644L17.9825 27.0001L21.3384 30.3561L19.1011 32.5934Z" fill="#FFD5D0" fill-opacity="0.3"/>
        <path d="M34.9014 32.5934L32.6641 30.3561L36.02 27.0001L32.6641 23.644L34.9014 21.4067L40.4946 27.0001L34.9014 32.5934Z" fill="#FFD5D0" fill-opacity="0.3"/>
        <path d="M23.8516 33.8223L27.0385 19.4883L30.1266 20.1749L26.9397 34.5089L23.8516 33.8223Z" fill="#FFD5D0" fill-opacity="0.3"/>
      </symbol>
      <symbol id="icon-cloud" viewBox="0 0 56 56" fill="none">
        <path d="M38.4314 36.0938H44.4706C50.8281 36.0938 56 30.942 56 24.6094C56 21.7528 54.9401 19.015 53.0151 16.9001C51.4564 15.1873 49.4358 13.9949 47.214 13.454C47.0969 6.0152 40.9856 0 33.4902 0C29.1903 0 25.2377 1.9585 22.6475 5.30682C21.2166 4.69415 19.6755 4.375 18.1176 4.375C11.7602 4.375 6.58824 9.52673 6.58824 15.8594C6.58824 16.531 6.64914 17.2014 6.76967 17.8657C2.84933 18.9825 0 22.5906 0 26.7969C0 31.923 4.18713 36.0938 9.33333 36.0938H17.5686V46.6143L13.2288 48.0554C12.3233 46.9009 10.9143 46.1562 9.33333 46.1562C6.60882 46.1562 4.39216 48.3643 4.39216 51.0781C4.39216 53.792 6.60882 56 9.33333 56C12.0278 56 14.2239 53.8403 14.2724 51.1674L19.7364 49.3533C20.4089 49.1299 20.8627 48.5031 20.8627 47.7969V36.0938H26.3529V46.4382C24.4357 47.1158 23.0588 48.9393 23.0588 51.0781C23.0588 53.792 25.2755 56 28 56C30.7245 56 32.9412 53.792 32.9412 51.0781C32.9412 48.9393 31.5643 47.1158 29.6471 46.4382V36.0938H35.1373V47.7969C35.1373 48.5031 35.5911 49.1299 36.2636 49.3533L41.7276 51.1674C41.7761 53.8403 43.9722 56 46.6667 56C49.3912 56 51.6078 53.792 51.6078 51.0781C51.6078 48.3643 49.3912 46.1562 46.6667 46.1562C45.0857 46.1562 43.6767 46.9009 42.7712 48.0554L38.4314 46.6143V36.0938ZM9.33333 52.7188C8.42531 52.7188 7.68627 51.9826 7.68627 51.0781C7.68627 50.1736 8.42531 49.4375 9.33333 49.4375C10.2414 49.4375 10.9804 50.1736 10.9804 51.0781C10.9804 51.9826 10.2414 52.7188 9.33333 52.7188ZM28 52.7188C27.092 52.7188 26.3529 51.9826 26.3529 51.0781C26.3529 50.1736 27.092 49.4375 28 49.4375C28.908 49.4375 29.6471 50.1736 29.6471 51.0781C29.6471 51.9826 28.908 52.7188 28 52.7188ZM3.29412 26.7969C3.29412 23.6451 5.769 21.0124 8.92843 20.8035C9.44357 20.7693 9.91281 20.4967 10.1963 20.0665C10.4798 19.6362 10.5442 19.0988 10.37 18.6147C10.0466 17.7119 9.88235 16.7852 9.88235 15.8594C9.88235 11.3361 13.5767 7.65625 18.1176 7.65625C19.5961 7.65625 21.0558 8.06085 22.3382 8.8269L22.3528 8.82349C24.8577 10.3231 26.3529 12.9524 26.3529 15.8594C26.3529 16.7656 27.0903 17.5 28 17.5C28.9097 17.5 29.6471 16.7656 29.6471 15.8594C29.6471 12.4397 28.0858 9.19305 25.4844 7.02905C27.4531 4.65912 30.3496 3.28125 33.4902 3.28125C39.242 3.28125 43.9216 7.9425 43.9216 13.6719C43.9216 13.9812 43.9048 14.3063 43.8705 14.6661C43.8701 14.6716 43.8705 14.6768 43.8701 14.6823C43.6681 16.731 42.8591 18.6899 41.5376 20.2835C40.9586 20.9821 41.0577 22.016 41.7589 22.5932C42.0661 22.8457 42.4375 22.9688 42.8068 22.9688C43.2812 22.9688 43.7521 22.7658 44.0777 22.3727C45.4352 20.7355 46.3831 18.8057 46.8601 16.7557C50.2803 17.7773 52.7059 20.9231 52.7059 24.6094C52.7059 29.1326 49.0116 32.8125 44.4706 32.8125H9.33333C6.00319 32.8125 3.29412 30.114 3.29412 26.7969ZM46.6667 49.4375C47.5747 49.4375 48.3137 50.1736 48.3137 51.0781C48.3137 51.9826 47.5747 52.7188 46.6667 52.7188C45.7586 52.7188 45.0196 51.9826 45.0196 51.0781C45.0196 50.1736 45.7586 49.4375 46.6667 49.4375Z" fill="#FFF0D3" fill-opacity="0.3"/>
      </symbol>
      <symbol id="icon-code" viewBox="0 0 28 28" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.82051 0C5.77324 0 4.76887 0.416023 4.02835 1.15656C3.28782 1.89708 2.87179 2.90145 2.87179 3.94872V11.1282C2.87179 11.6042 2.68269 12.0608 2.34608 12.3974C2.00948 12.734 1.55295 12.9231 1.07692 12.9231C0.48216 12.9231 0 13.4053 0 14C0 14.5947 0.48216 15.0769 1.07692 15.0769C1.55295 15.0769 2.00948 15.266 2.34608 15.6026C2.68269 15.9392 2.87179 16.3958 2.87179 16.8718V24.0513C2.87179 26.2255 4.64626 28 6.82051 28H8.25641C8.85117 28 9.33333 27.5178 9.33333 26.9231C9.33333 26.3283 8.85117 25.8462 8.25641 25.8462H6.82051C5.83579 25.8462 5.02564 25.036 5.02564 24.0513V16.8718C5.02564 15.8246 4.60962 14.8202 3.86908 14.0797C3.84212 14.0527 3.81479 14.0261 3.78712 14C3.81479 13.9739 3.84212 13.9473 3.86908 13.9203C4.60962 13.1798 5.02564 12.1754 5.02564 11.1282V3.94872C5.02564 3.47269 5.21475 3.01616 5.55135 2.67956C5.88795 2.34295 6.34448 2.15385 6.82051 2.15385H8.25641C8.85117 2.15385 9.33333 1.67169 9.33333 1.07692C9.33333 0.48216 8.85117 0 8.25641 0H6.82051ZM19.7436 0C19.1488 0 18.6667 0.48216 18.6667 1.07692C18.6667 1.67169 19.1488 2.15385 19.7436 2.15385H21.1795C21.6555 2.15385 22.1121 2.34295 22.4487 2.67956C22.7853 3.01616 22.9744 3.47269 22.9744 3.94872V11.1282C22.9744 12.1754 23.3903 13.1798 24.131 13.9203C24.1587 13.9482 24.1868 13.9754 24.2154 14.0024C23.4521 14.7233 22.9744 15.7438 22.9744 16.8718V24.0513C22.9744 24.5273 22.7853 24.9839 22.4487 25.3205C22.1121 25.657 21.6555 25.8462 21.1795 25.8462H19.7436C19.1488 25.8462 18.6667 26.3283 18.6667 26.9231C18.6667 27.5178 19.1488 28 19.7436 28H21.1795C22.2267 28 23.2311 27.584 23.9716 26.8434C24.7122 26.1029 25.1282 25.0985 25.1282 24.0513V16.8718C25.1282 15.8871 25.9383 15.0769 26.9231 15.0769C27.5178 15.0769 28 14.5947 28 14C28 13.4053 27.5178 12.9231 26.9231 12.9231C26.4471 12.9231 25.9905 12.734 25.6539 12.3974C25.3173 12.0608 25.1282 11.6042 25.1282 11.1282V3.94872C25.1282 2.90145 24.7122 1.89708 23.9716 1.15656C23.2311 0.416023 22.2267 0 21.1795 0H19.7436Z" fill="#D9DEF2" fill-opacity="0.34"/>
      </symbol>
      <symbol id="icon-graph" viewBox="0 0 38 53" fill="none">
        <path d="M17.8412 0C20.2863 0 21.669 0.390249 23.2933 2.14109L23.4812 2.34888L35.8869 16.2164C37.375 17.8934 37.8468 19.1317 37.9647 21.316L37.9877 21.8824L37.9973 22.4931L37.9992 45.2625C37.9992 50.302 35.7756 52.8956 31.3083 52.9968L31.0322 53H7.16626C2.62896 53 0.294146 50.5309 0.202096 45.5695L0.199219 45.2625V7.76173C0.199219 2.7233 2.4439 0.105472 6.89107 0.00316395L7.16626 0H17.8412ZM17.3464 3.97948H7.36858C5.10568 3.97948 3.89752 5.3 3.82082 7.60247L3.81698 7.83662V45.1887C3.81698 47.5808 4.95418 48.9309 7.12503 49.0152L7.34557 49.0205H30.8529C33.1148 49.0205 34.3028 47.7464 34.3776 45.4239L34.3815 45.1887V22.9899H21.5711C18.8643 22.9899 17.4289 21.5438 17.3493 18.6054L17.3464 18.3417V3.97948ZM9.63148 31.6998C10.459 31.6998 11.1292 32.4381 11.1292 33.3483V44.887C11.1292 45.7962 10.458 46.5345 9.63148 46.5345H8.13279C7.3053 46.5345 6.6341 45.7962 6.6341 44.886V33.3473C6.6341 32.4381 7.3053 31.6998 8.13279 31.6998H9.63148ZM23.1178 36.6444C23.9453 36.6444 24.6155 37.3827 24.6155 38.2929V44.886C24.6155 45.7962 23.9443 46.5345 23.1178 46.5345H21.6191C20.7916 46.5345 20.1204 45.7962 20.1204 44.886V38.2939C20.1204 37.3827 20.7916 36.6444 21.6191 36.6444H23.1178ZM16.3742 26.7552C17.2016 26.7552 17.8728 27.4936 17.8728 28.4027V44.886C17.8728 45.7962 17.2016 46.5345 16.3742 46.5345H14.8755C14.048 46.5345 13.3777 45.7962 13.3777 44.886V28.4038C13.3777 27.4936 14.0489 26.7563 14.8755 26.7563L16.3742 26.7552ZM20.7398 4.74627V17.8723C20.7398 18.8037 21.0582 19.2087 21.8262 19.253L21.9758 19.2572H33.6834L20.7398 4.74627Z" fill="#C6EABA" fill-opacity="0.35"/>
      </symbol>
      <symbol id="icon-play-black-white" viewBox="0 0 31 30" fill="none">
        <rect x="0.5" width="30" height="30" rx="15" fill="white"/>
        <path d="M21.5 14.634C22.1667 15.0189 22.1667 15.9811 21.5 16.366L13.25 21.1292C12.5833 21.5141 11.75 21.0329 11.75 20.2631L11.75 10.7369C11.75 9.96706 12.5833 9.48593 13.25 9.87083L21.5 14.634Z" fill="black"/>
      </symbol>
      <symbol id="icon-play" viewBox="0 0 31 30" fill="none">
        <rect x="0.5" width="30" height="30" rx="15" fill="#5667FF"/>
        <path d="M21.5 14.634C22.1667 15.0189 22.1667 15.9811 21.5 16.366L13.25 21.1292C12.5833 21.5141 11.75 21.0329 11.75 20.2631L11.75 10.7369C11.75 9.96706 12.5833 9.48593 13.25 9.87083L21.5 14.634Z" fill="white"/>
      </symbol>
    </sprites>
  </div>
</template>


<style lang="scss" scoped>
.page-index {
  &-h1 {
    @include font-size(46px);
    font-weight: 600;
    line-height: 1.2em;
    letter-spacing: -1.8px;
    @include onMD {
      text-align: center;
    }
    @include onXS {
      text-align: center;
      @include font-size(40px);
    }
  }

  &-description {
    width: 100%;
    display: grid;
    grid-template-columns: 40px 1.2fr .8fr;
    gap: 0px;
    align-items: center;
    @include onSM {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    @include onXS {
      text-align: center;
    }
    .s-1 {
      @include font-size(32px);
      font-weight: 600;
      line-height: 1.2em;
      margin-bottom: 17px;
      letter-spacing: -1.2px;
      padding-right: 20px;
      @include onXS {
        @include font-size(27px);
      }
    }

    .s-2 {
      @include font-size(20px);
      --min-font-size: 14px;
      font-weight: 300;
      line-height: 1.5em;
      margin-bottom: 12px;
      letter-spacing: -.7px;
    }

    @keyframes up-down-arrow {
      0% {
        transform: translateY(0%) translateX(-6px);
      }
      50% {
        transform: translateY(3%) translateX(-6px);
      }
      100% {
        transform: translateY(0%) translateX(-6px);
      }
    }

    .icon {
      transform: translateX(-6px);
      height: 140px;
      width: 14px;
      animation: infinite 1.5s up-down-arrow ease-in-out;

      @include onSM {
        height: 70px;
        order: 3;
        transform: rotate(180deg)!important;
      }
    }
  }

  &-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    color: #fff;
    @include onMD {
      margin-bottom: 30px;
    }

    @include onSM {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }

    @include onXXS {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    &-row {
      padding: 30px 40px;
      position: relative;
      @include onMD {
        padding: 20px!important;
      }
      @include onXS {
        padding: 10px!important;
      }
      @include onSM {
        padding: 0!important;
      }

      @mixin vertical-line() {
        content: "";
        display: block;
        background: $GRAY_LINE;
        position: absolute;
        top: 0;
        height: 100%;
        width: 1px;
      }
      @mixin horizontal-line() {
        top: auto;
        left: 0;
        height: 1px;
        width: 100%;
      }

      &:nth-child(1) {
        grid-column: auto/span 2;
        padding-right: 60px;
        padding-top: 75px;
        padding-bottom: 75px;
        padding-left: 0;
        border-bottom: 1px $GRAY_LINE solid;
        order: 11;
        @include onMD {
          grid-column: auto/span 3;
          display: flex;
          align-items: center;
          padding: 30px 0!important;
        }
        @include onSM {
          grid-column: auto/span 2;
        }
      }

      &:nth-child(2) {
        order: 22;
        padding-left: 53px;
        padding-top: 75px;
        border-bottom: 1px $GRAY_LINE solid;
        padding-right: 0;
        @include onMD {
          padding-top: 10px!important;
          //margin-bottom: 20px;
          grid-column: auto/span 3;
          border-bottom: none;
        }
        @include onSM {
          grid-column: auto/span 2;
        }

        &:before {
          content: "";
          @include vertical-line;
          left: 22px;
          @include onMD {
            left: 0;
            display: none;
          }
        }
      }

      &:nth-child(3) {
        order: 33;
        padding-left: 0;
        padding-right: 55px;
        border-bottom: 1px $GRAY_LINE solid;
        @include onSM {
          border-bottom: none;
        }

        @include onXXS {
          margin-bottom: 20px;
        }

        &:after {
          content: "+";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          color: #fff;
          @include font-size(50px);
          //font-weight: bold;
          @include onMD {
            right: -12px;
          }
          @include onSM {
            right: -26px;
            @include font-size(50px);
            z-index: 222;
          }
          @include onXXS {
            right: 50%;
            top: 100%;
            @include font-size(50px);
            transform: translateX(50%) translateY(0%);
          }
        }
      }

      &:nth-child(4) {
        order: 44;
        padding-left: 25px;
        padding-right: 10px;
        border-bottom: 1px $GRAY_LINE solid;
        @include onSM {
          border-bottom: none;
        }
      }

      &:nth-child(5) {
        order: 55;
        padding-right: 0;
        padding-left: 53px;
        border-bottom: 1px $GRAY_LINE solid;
        @include onSM {
          border-bottom: none;
        }

        .page-index-tile__icon {
          //top: 40%;
          .icon {
            width: 73.798px;
            height: 45.636px;
            @include onXS {
              width: 45px;
              height: 35px;
            }
          }
        }
        &:before {
          content: "";
          @include vertical-line;
          left: 22px;
          @include onMD {
            left: 0;
          }
          @include onSM {
            display: none;
          }
        }
      }

      &:nth-child(6) {
        order: 66;
        padding-left: 0;
        padding-right: 55px;

        &:before {
          content: "";
          @include vertical-line;
          right: 22px;
          @include onMD {
            right: 0;
            display: none;
          }
        }
      }

      &:nth-child(7) {
        order: 77;
        display: flex;
        justify-content: flex-start;
        padding-left: 25px;
        padding-right: 0;
        grid-column: auto/span 2;
        @include onMD {
          padding: 30px 0!important;
          padding-bottom: 0!important;
        }
        @include onSM {
          grid-column: auto/span 2;
          order: 23;
        }
      }

      &:nth-child(8) {
        order: 88;
        display: flex;
        align-items: center;
        padding-left: 55px;
        padding-right: 0;
        @include onSM {
          padding: 0 0 30px 0!important;
        }
        @include onSM {
          grid-column: auto/span 2;
        }

        //&:before {
        //  content: "";
        //  @include vertical-line;
        //  left: 22px;
        //  @include onMD {
        //    right: 0;
        //    display: none;
        //  }
        //}
      }
    }

    &-min-rf {
      .buttons {
        gap: 20px;
        display:flex;
        flex-direction: column;
        width: 100%;
        @include onMD {
          max-width: 300px;
          margin: auto;
        }
      }
    }

    &-more {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 30px;

      .s-1 {
        @include font-size(28px);
        font-weight: 600;
        line-height: 1.2em;
        //margin-bottom: 30px;
        letter-spacing: -1px;

        @include onLG {
          margin-bottom: 0;
        }
        @include onSM {
          text-align: center;
          margin-bottom: 15px;
        }
        @include onXS {
          line-height: 1.5em;
        }
      }
      .buttons {
        display: flex;
        gap: 15px;
        @include font-size(16px);
        --min-font-size: 13px;
        @include onLG {
          flex-wrap: wrap;
          white-space: nowrap;
          align-items: center;
          justify-content: center;
        }

        @include onSM {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        }
        @include onXXS {
          display: flex;
        }

        .btn {
          padding-left: 11px;
          padding-right: 11px;
          @include onLG {
            width: 100%;
          }
        }
      }
    }

    &-more-v2 {
      grid-column: auto/span 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      justify-content: space-between;
      border: 2px $VIOLET solid;
      border-radius: var(--main-border-radius);
      position: relative;
      padding: 0!important;

      @include onMD {
        margin: 20px 0px;
      }

      @include onSM {
        margin: 0 20px;
      }

      @keyframes scalePulse {
        0% {
          transform: scale(1);
          opacity: .7;
        }
        100% {
          opacity: 0;
          transform: scale(1.1, 1.2);
        }
      }

      @keyframes scalePulseXXS {
        0% {
          transform: scale(1);
          opacity: .7;
        }
        100% {
          opacity: 0;
          transform: scale(1.1, 1.25);
        }
      }

      &:after {
        content: "";
        display: block;
        position: absolute;
        pointer-events: none;
        touch-action: none;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        border-radius: inherit;
        border: 2px rgba(86, 103, 255, .5) solid;
        transform: scale(0);
        animation: scalePulse 2s infinite ease;
        box-shadow: 0 0 20px 0 $VIOLET;
        @include onXS {
          animation: scalePulseXXS 2s infinite ease;
        }
      }

      .s-1 {
        font-weight: 600;
        @include font-size(24px);
        --min-font-size: 16px;
        line-height: 120%;
        text-align: center;
        flex: none;
        align-self: stretch;
        flex-grow: 0;
        margin: 20px 20px 0;
      }
      .s-2 {
        font-size: 1.15em;
      }
      .buttons {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;
        .btn {
          min-width: 160px;
          max-width: 100%;
          padding: 12px 25px;
        }
      }
    }
  }

  &-tile {
    border-radius: var(--main-border-radius);
    background: $VIOLET;
    box-shadow: 0 4px 20px 0 $VIOLET;
    position: relative;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    padding: 20px 70px 20px 20px;
    justify-content: flex-start;
    align-items: flex-start;
    transition: all .20s ease;
    color: #fff;
    text-decoration: none;
    @include onSM {
      min-height: 160px;
    }
    @include onXS {
      min-height: 100%;
      padding: 15px;
    }

    &:hover {
      transform: scale(1.02);
      cursor: pointer;
      .page-index-tile__more {
        text-decoration: none;
        svg {
          transform: rotate(-90deg) translateX(10px);
        }
      }
    }

    &--red {
      background: $RED;
      box-shadow: 0 4px 20px 0 rgba(193, 69, 56, 0.25);
      &:hover {
        box-shadow: 0 4px 30px 0 rgba(193, 69, 56, 0.55);
      }
    }

    &--orange {
      background: $ORANGE;
      box-shadow: 0 4px 20px 0 rgba(255, 154, 62, 0.25);
      &:hover {
        box-shadow: 0 4px 30px 0 rgba(255, 154, 62, 0.55);
      }
    }

    &--blue {
      background: $BLUE;
      box-shadow: 0 4px 20px 0 rgba(86, 118, 233, 0.25);
      &:hover {
        box-shadow: 0 4px 30px 0 rgba(86, 118, 233, 0.55);
      }
    }

    &--green {
      background: $GREEN;
      box-shadow: 0 4px 20px 0 rgba(119, 185, 125, 0.25);
      &:hover {
        box-shadow: 0 4px 30px 0 rgba(119, 185, 125, 0.55);
      }
    }

    &__icon {
      position: absolute;
      right: 20px;
      top: 20px;
      flex-shrink: 0;

      svg {
        width: 54px;
        height: 54px;
        @include onXS {
          width: 35px;
          height: 35px;
        }
      }
    }

    &__title {
      @include font-size(32px);
      font-weight: 600;
      line-height: 1.2em;
      margin-bottom: 15px;
      flex-shrink: 0;
    }

    &__descr {
      @include font-size(15px);
      font-weight: 400;
      line-height: 1.5em;
      flex-shrink: 0;
      flex-grow: 1;
    }

    &__more {
      @include font-size(16px);
      font-weight: 400;
      line-height: 1.2em;
      flex-shrink: 0;
      text-decoration: underline;
      color: #fff;
      transition: all .25s ease;
      margin-top: 20px;
      //&:hover {
      //  text-decoration: none;
      //  transform: translateX(5px);
      //}

      svg {
        margin-left: 7px;
        transform: translateY(30%);
        width: 19px;
        transition: all .25s ease;
      }
    }
  }
}
</style>
